export default __webpack_public_path__ + "locales/lo-LA/FillPDFDialog.json?hash=130a4a67761d939d9f05fe548cdf4d83";